// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"5b4cdbc7","453":"36c0b50e","638":"bd501c21","656":"5ca881b1","765":"4c531803"}[chunkId] + ".chunk.js";
};